import React from "react";
import * as ReactBootstrap from "react-bootstrap";
import PropTypes from "prop-types";

import "./DateFormControlComponent.css";


const DateFormControl = ({ onChange, value, placeholder, name }) => {

  return (

    <div className="form-control-wrapper">

      <ReactBootstrap.Form.Control
        className="form-control-custom"
        type="date"
        placeholder={placeholder}
        name={name}
        onChange={(e)=>onChange(name,e)}
        value={value || ""}
      />

    </div>

  );
}


DateFormControl.propTypes = {
  placeholder: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};


DateFormControl.defaultProps = {
  value:""
};


export default DateFormControl;